import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import StepIndicator from "../components/StepIndicator";
import { useApp } from "../context/AppContext";

const validateUSPhone = (digits) => /^\d{10}$/.test(digits);

const PersonalInfoPage = () => {
  const navigate = useNavigate();
  const { userData, updateUserData } = useApp();

  const [firstName,   setFirstName]   = useState(userData.firstName);
  const [lastName,    setLastName]    = useState(userData.lastName);
  const [email,       setEmail]       = useState(userData.email);
  const [phone,       setPhone]       = useState(userData.phoneNumber);
  const [phoneError,  setPhoneError]  = useState("");
  const [emailError,  setEmailError]  = useState("");

  const formatDisplay = (digits) => {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6,10)}`;
  };

  const handlePhoneChange = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    setPhone(digits);
    if (digits.length === 0)       setPhoneError("");
    else if (digits.length < 10)   setPhoneError("Must be 10 digits");
    else                           setPhoneError("");
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
      setEmailError("Please enter a valid email address");
    else setEmailError("");
  };

  const isValid =
    firstName.trim().length >= 2 &&
    lastName.trim().length  >= 2 &&
    email.trim() && !emailError &&
    validateUSPhone(phone)  && !phoneError;

  const handleNext = () => {
    updateUserData({ firstName, lastName, email, phoneNumber: phone });
    navigate("/venmo");
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      <main className="form-main">
        <div className="card">
          <h2 className="card-title">Personal Information</h2>
          <p className="card-subtitle">Step 2 of 3 — Tell us about yourself</p>
          <StepIndicator current={2} total={3} />

          <div className="form-group">
            <div className="name-row">
              <div>
                <label className="form-label">First Name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="John"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div>
                <label className="form-label">Last Name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Smith"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              placeholder="john.smith@gmail.com"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
              style={{ borderColor: emailError ? "#ef4444" : undefined }}
            />
            {emailError && (
              <p className="field-error">⚠ {emailError}</p>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">U.S. Phone Number</label>
            <div className="phone-row">
              <div className="phone-code">🇺🇸 +1</div>
              <div style={{ flex: 1 }}>
                <input
                  type="tel"
                  className="form-input"
                  placeholder="(555) 867-5309"
                  value={formatDisplay(phone)}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  style={{ borderColor: phoneError ? "#ef4444" : undefined }}
                />
                {phoneError ? (
                  <p className="field-error">⚠ {phoneError}</p>
                ) : (
                  <p className="form-hint">10-digit US number, no dashes needed</p>
                )}
              </div>
            </div>
          </div>

          <div className="btn-row">
            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
              ← BACK
            </button>
            <button
              className="btn btn-primary"
              onClick={handleNext}
              disabled={!isValid}
            >
              NEXT STEP →
            </button>
          </div>
        </div>
      </main>
      <footer className="page-footer">© 2026 WinBig LLC. All rights reserved.</footer>
    </div>
  );
};

export default PersonalInfoPage;
